import React, { createContext, useContext, useState, useCallback } from 'react';

const noop = () => {};
const SupportChatbotContext = createContext({
  openPanel: noop,
  openForOrder: noop,
});

export const useSupportChatbot = () => useContext(SupportChatbotContext);
export const SupportChatbotProvider = SupportChatbotContext.Provider;
export default SupportChatbotContext;
